module.exports = __webpack_public_path__ + "img/wshop.e8e6e883.svg";